import type {
  DuplicatedValue,
  OmittedValue,
  PreviewIssueTargetYear,
} from "@/apis/preview/v2/types";

export type PreviewPeriod = "CURRENT" | "PREVIOUS";

export type PreviewIssueKind = "omitted" | "duplicated";

export const normalizeBegend = (begend?: string | null) => {
  if (begend === "BEGIN" || begend === "END") return begend;
  return "NONE";
};

export const getPreviewIssueTargetYear = (
  previewTargetYear: PreviewPeriod,
): PreviewIssueTargetYear =>
  previewTargetYear === "CURRENT" ? "CURRENT" : "PRIOR";

export const matchesPreviewIssueTargetYear = (
  targetYear: PreviewIssueTargetYear | null | undefined,
  previewTargetYear: PreviewPeriod,
) => {
  return (
    !targetYear || targetYear === getPreviewIssueTargetYear(previewTargetYear)
  );
};

export const getPreviewIssueKey = (
  issueValue: OmittedValue | DuplicatedValue,
  index: number,
  issueKind: PreviewIssueKind,
  sourceKey: string,
) =>
  [
    issueKind,
    issueValue.roleKey ?? "NONE",
    issueValue.targetYear ?? "ALL",
    issueValue.cellTagKey ?? "NONE",
    normalizeBegend(issueValue.begend),
    issueValue.accumulatedType ?? "NONE",
    sourceKey,
    index,
  ].join(":");

export const getFilteredPreviewIssues = (
  omittedValues: OmittedValue[] | undefined,
  duplicatedValues: DuplicatedValue[] | undefined,
  period: PreviewPeriod,
) => {
  return {
    filteredOmittedValues: (omittedValues ?? []).filter((v) =>
      matchesPreviewIssueTargetYear(v.targetYear, period),
    ),
    filteredDuplicatedValues: (duplicatedValues ?? []).filter((v) =>
      matchesPreviewIssueTargetYear(v.targetYear, period),
    ),
  };
};

export const getPreviewIssueMetaLabel = ({
  accumulatedType,
}: Pick<OmittedValue | DuplicatedValue, "accumulatedType">) => {
  const labels: string[] = [];

  if (accumulatedType) labels.push(accumulatedType);

  return labels.join(" / ");
};
